import SimpleDialog from '~/components/dialog/SimpleDialog';
import SignInUpFlow from './SignInUpFlow';
import { useCommonAppContext } from '../contexts/CommonAppContext';

// Handles showing and closing the sign in flow dialog
export default function SignInFlowDialog() {
  const {
    showSignInDialog,
    setShowSignInDialog,
    initialSignInMode,
  } = useCommonAppContext();


  return (
    <SimpleDialog open={showSignInDialog} onClose={() => setShowSignInDialog(false)}>
      <SignInUpFlow initialSignInMode={initialSignInMode} />
    </SimpleDialog>
  );
}; 